export default __webpack_public_path__ + "static/media/icon-face-normal-16x10.0c68d1fc.svg";